import styled from 'styled-components';

const Body = styled.div`
  padding: 20px;
  box-sizing: border-box;
`;

export default Body;
